import './NotFound.css'

export default function NotFound() {
  return (
    <section>
      <h1>Not Found</h1>
      <p>ストーリーは非公開設定されているか、存在しません。</p>
    </section>
  )
}
